import cloneDeep from 'lodash/cloneDeep';

export function transformAdHocQuestions(adHocQuestions) {
  const questions = cloneDeep(adHocQuestions);

  questions.forEach((field) => {
    if (field.type === 'CHECKBOX_GROUP') {
      field.name = field.name.replace(/\[]$/, '');
      field.layout = 'COLUMN';

      field.options.forEach((option) => {
        option.value = replaceSpecialCharacters(option.value);
      });
    }

    if (field.type === 'SELECT') {
      if (/country$/.test(field.name)) {
        field.optionsSource = 'countries';
      }

      if (/state$/.test(field.name)) {
        field.optionsSource = 'regions';
      }
    }
  });

  return questions;
}

function replaceSpecialCharacters(value) {
  return value
    .replace(/\./g, '__dot__')
    .replace(/,/g, '__cma__')
    .replace(/'/g, '__apos__');
}
